import { useTranslation } from "react-i18next";
import { GetCurrentYear } from "../Helpers/Utilities";

const MainFooter = () => {
  const { t: translation } = useTranslation();
  const currentYear = GetCurrentYear();

  return (
    <footer className="main-footer position-absolute">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="copyright-sec">
              <p className="fs-4">
                ©{currentYear}{" "}
                <a
                  className="footer-link fs-4"
                  href="https://www.edot-solutions.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {translation("labels.edot")}.
                </a>{" "}
                {translation("labels.footerText")}.&nbsp;
                <a
                  className="footer-terms-condition fs-4"
                  href="/TermsAndConditions"
                  target="blank"
                >
                  {translation("labels.terms")}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
